import React from "react";
import { Checkbox, Grid, TextField, Typography } from "@mui/material";

const SingleAbroadComponent = ({
  onChange,
  practice,
  errors,
  tooltipContent,
  handleModalClick,
}) => {
  const handleInputChange = (field, event) => {
    const { value } = event.target;
    onChange(field, value);
  };

  return (
    <>
      {practice?.cliente?.status === "Già cliente LEXIA" ? (
        <>
          {/* Nome */}
          <Grid item xs={11} md={4}>
            <div
              style={{
                display: "flex",
                height: "20px",
              }}
            >
              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px" }}
              >
                Nome
              </Typography>
            </div>

            <TextField
              style={{ marginTop: "10px" }}
              placeholder="Inserisci"
              variant="outlined"
              value={practice?.cliente?.nome}
              error={errors.includes("nome")}
              onChange={(e) => handleInputChange("nome", e)}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #1b2838",
                  },
                },
              }}
              InputProps={{
                style: {
                  color: "#1b2838",
                },
              }}
            />
          </Grid>

          {/* Cognome */}
          <Grid item xs={11} md={4}>
            <div
              style={{
                display: "flex",
                height: "20px",
              }}
            >
              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px" }}
              >
                Cognome
              </Typography>
            </div>

            <TextField
              style={{ marginTop: "10px" }}
              placeholder="Inserisci"
              value={practice?.cliente?.cognome}
              error={errors.includes("cognome")}
              onChange={(e) => handleInputChange("cognome", e)}
              variant="outlined"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #1b2838",
                  },
                },
              }}
              InputProps={{
                style: {
                  color: "#1b2838",
                },
              }}
            />
          </Grid>
        </>
      ) : (
        <>
          {" "}
          {/* Nome */}
          <Grid item xs={11} md={4}>
            <div
              style={{
                display: "flex",
                height: "20px",
              }}
            >
              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px" }}
              >
                Nome
              </Typography>
            </div>

            <TextField
              style={{ marginTop: "10px" }}
              placeholder="Inserisci"
              variant="outlined"
              value={practice?.cliente?.nome}
              error={errors.includes("nome")}
              onChange={(e) => handleInputChange("nome", e)}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #1b2838",
                  },
                },
              }}
              InputProps={{
                style: {
                  color: "#1b2838",
                },
              }}
            />
          </Grid>
          {/* Cognome */}
          <Grid item xs={11} md={4}>
            <div
              style={{
                display: "flex",
                height: "20px",
              }}
            >
              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px" }}
              >
                Cognome
              </Typography>
            </div>

            <TextField
              style={{ marginTop: "10px" }}
              placeholder="Inserisci"
              value={practice?.cliente?.cognome}
              error={errors.includes("cognome")}
              onChange={(e) => handleInputChange("cognome", e)}
              variant="outlined"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #1b2838",
                  },
                },
              }}
              InputProps={{
                style: {
                  color: "#1b2838",
                },
              }}
            />
          </Grid>
          {/* Comune */}
          <Grid item xs={11} md={4}>
            <div
              style={{
                display: "flex",
                height: "20px",
              }}
            >
              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px" }}
              >
                Comune
              </Typography>
            </div>

            <TextField
              style={{ marginTop: "10px" }}
              placeholder="Inserisci"
              value={practice?.cliente?.comune}
              error={errors.includes("comune")}
              onChange={(e) => handleInputChange("comune", e)}
              variant="outlined"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #1b2838",
                  },
                },
              }}
              InputProps={{
                style: {
                  color: "#1b2838",
                },
              }}
            />
          </Grid>
          {/* Indirizzo/ num civico */}
          <Grid item xs={11} md={4}>
            <div
              style={{
                display: "flex",
                height: "20px",
              }}
            >
              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px" }}
              >
                Indirizzo e Civico
              </Typography>
            </div>

            <TextField
              style={{ marginTop: "10px" }}
              placeholder="Inserisci"
              value={practice?.cliente?.indirizzo}
              error={errors.includes("indirizzo")}
              onChange={(e) => handleInputChange("indirizzo", e)}
              variant="outlined"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #1b2838",
                  },
                },
              }}
              InputProps={{
                style: {
                  color: "#1b2838",
                },
              }}
            />
          </Grid>
          {/* CAP */}
          <Grid item xs={11} md={4}>
            <div
              style={{
                display: "flex",
                height: "20px",
              }}
            >
              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px" }}
              >
                CAP (facoltativo)
              </Typography>
            </div>

            <TextField
              style={{ marginTop: "10px" }}
              placeholder="Inserisci"
              variant="outlined"
              value={practice?.cliente?.CAP}
              error={errors.includes("CAP")}
              onChange={(e) => handleInputChange("CAP", e)}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #1b2838",
                  },
                },
              }}
              InputProps={{
                style: {
                  color: "#1b2838",
                },
              }}
            />
          </Grid>
          <Grid item xs={11} md={4} style={{ padding: 0 }}></Grid>
          {/* Appartenenza Cliente */}
          <Grid
            item
            xs={11}
            md={4}
            sx={
              {
                // mt: {
                //   xs: 0,
                //   md:
                //     practice?.cliente?.cliente_affiliato_gruppo_societari === "Sì"
                //       ? "30px"
                //       : "30px",
                // },
              }
            }
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                borderRadius: "0px",
                // padding: "15px 14px",
                padding: 0,
              }}
            >
              <Checkbox
                sx={{
                  transform: "scale(1.1)",
                  padding: 0,
                  marginRight: "10px",
                  color: "#929292ff",
                  "&.Mui-checked": {
                    color: "#afaeaeff",
                  },
                }}
                inputProps={{ style: { margin: 0, padding: 0 } }}
                checked={
                  practice?.cliente?.cliente_affiliato_gruppo_societari === "Sì"
                }
                error={errors.includes("cliente_affiliato_gruppo_societari")}
                onChange={(e) =>
                  handleInputChange("cliente_affiliato_gruppo_societari", {
                    target: { value: e.target.checked ? "Sì" : "" },
                  })
                }
              />

              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px", marginTop: "2px" }}
              >
                Il Cliente è affiliato a gruppi societari?
              </Typography>

              <div
                className="icon-modal-info"
                style={{ marginLeft: "10px", cursor: "pointer" }}
                onClick={() =>
                  handleModalClick(
                    tooltipContent.cliente_affiliato_gruppo_societari
                  )
                }
              />
            </div>
          </Grid>
          <Grid item xs={11} md={4} style={{ padding: 0 }}></Grid>
          <Grid item xs={11} md={4} style={{ padding: 0 }}></Grid>
          {practice?.cliente?.cliente_affiliato_gruppo_societari === "Sì" ? (
            <>
              {/* cliente_collegamento_societa */}
              <Grid item xs={11} md={4}>
                <div
                  style={{
                    display: "flex",
                    height: "20px",
                  }}
                >
                  <Typography
                    className="color-blue-dark"
                    style={{ fontSize: "14px" }}
                  >
                    Società/gruppo con cui il cliente è collegato
                  </Typography>
                  <div
                    className="icon-modal-info"
                    style={{ marginLeft: "10px", cursor: "pointer" }}
                    onClick={() =>
                      handleModalClick(
                        tooltipContent.cliente_collegamento_societa
                      )
                    }
                  />
                </div>

                <TextField
                  style={{ marginTop: "10px" }}
                  multiline
                  rows={5}
                  placeholder="Inserisci"
                  variant="outlined"
                  value={practice?.cliente?.cliente_collegamento_societa}
                  error={errors.includes("cliente_collegamento_societa")}
                  onChange={(e) =>
                    handleInputChange("cliente_collegamento_societa", e)
                  }
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0px",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid #1b2838",
                      },
                    },
                  }}
                  InputProps={{
                    style: {
                      color: "#1b2838",
                    },
                  }}
                />
              </Grid>

              {/* cliente ruolo */}
              <Grid item xs={11} md={4}>
                <div
                  style={{
                    display: "flex",
                    height: "20px",
                  }}
                >
                  <Typography
                    className="color-blue-dark"
                    style={{ fontSize: "14px" }}
                  >
                    Ruolo
                  </Typography>
                  <div
                    className="icon-modal-info"
                    style={{ marginLeft: "10px", cursor: "pointer" }}
                    onClick={() =>
                      handleModalClick(tooltipContent.cliente_ruolo)
                    }
                  />
                </div>

                <TextField
                  style={{ marginTop: "10px" }}
                  multiline
                  rows={5}
                  placeholder="Inserisci"
                  variant="outlined"
                  value={practice?.cliente?.cliente_ruolo}
                  error={errors.includes("cliente_ruolo")}
                  onChange={(e) => handleInputChange("cliente_ruolo", e)}
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0px",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid #1b2838",
                      },
                    },
                  }}
                  InputProps={{
                    style: {
                      color: "#1b2838",
                    },
                  }}
                />
              </Grid>

              {/* Altro*/}
              <Grid item xs={11} md={4}>
                <div
                  style={{
                    display: "flex",
                    height: "20px",
                  }}
                >
                  <Typography
                    className="color-blue-dark"
                    style={{ fontSize: "14px" }}
                  >
                    Altro (facoltativo)
                  </Typography>
                </div>

                <TextField
                  style={{ marginTop: "10px" }}
                  multiline
                  rows={5}
                  placeholder="Controparti o soggetti co-interessati o contro-interessati rispetto alle attività rientranti nell’incarico"
                  variant="outlined"
                  value={practice?.cliente?.cliente_altro}
                  error={errors.includes("cliente_altro")}
                  onChange={(e) => handleInputChange("cliente_altro", e)}
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0px",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid #1b2838",
                      },
                    },
                  }}
                  InputProps={{
                    style: {
                      color: "#1b2838",
                    },
                  }}
                />
              </Grid>
            </>
          ) : null}
        </>
      )}
    </>
  );
};

export default SingleAbroadComponent;
